import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceBundleService } from '../../modules/core/services/resource-bundle.service';
import { GuestService } from '../../modules/core/services/guest.service';

@Component({
    selector: 'app-olci-checkin-container',
    templateUrl: './checkin.container.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckInContainerComponent {
	constructor(public resourceBundle: ResourceBundleService, public guestService: GuestService) {}
}
